export default function BpoSection() {
  return (
    <section id="bpo" className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-100 rounded-full mb-6">
            <span className="text-sm font-semibold text-accent-700">
              最大の特徴
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            就労支援と連携したBPO
          </h2>
          <p className="text-lg text-primary-500 font-medium mb-6">
            ビジネスと社会貢献、両方叶える新しい働き方
          </p>
          <p className="text-base text-foreground-600 leading-relaxed">
            フライズグループは障がい者支援・就労継続支援の事業も展開しています。ヴェリテはその仕組みを活かして、事務作業を就労支援の参加者と分担して実施します。
          </p>
        </div>

        {/* Visual + Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative overflow-hidden rounded-2xl aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Diverse%20team%20members%20collaborating%20happily%20in%20modern%20bright%20office%2C%20warm%20inclusive%20workplace%20atmosphere%2C%20people%20working%20together%20at%20shared%20desk%20with%20documents%20and%20laptops%2C%20soft%20natural%20light%2C%20editorial%20photography%20with%20warm%20neutral%20tones%20and%20professional%20composition&width=1200&height=900&seq=verite-bpo-collab&orientation=landscape"
              alt="Collaboration"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          </div>

          {/* Flow Diagram */}
          <div className="flex flex-col gap-6">
            {bpoItems.map((item) => (
              <div
                key={item.num}
                className="flex items-start gap-5 p-6 bg-background-100 rounded-xl border border-background-300 hover:border-primary-300 transition-colors"
              >
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading font-bold text-accent-600">
                    {item.num}
                  </span>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary CTA — warm dark instead of cold black */}
        <div className="text-center">
          <div className="inline-block p-8 bg-primary-800 text-background-50 rounded-2xl max-w-2xl">
            <p className="text-base md:text-lg leading-relaxed mb-6">
              データ入力や書類整理 → 就労支援の参加者が担当
              <br />
              品質管理・窓口対応 → ヴェリテが担当
            </p>
            <p className="text-sm text-background-300 leading-relaxed">
              つまり「本業に集中したい中小企業」にとって、事務作業をアウトソースできる + 社会貢献にも繋がる、という二重の価値があります。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

const bpoItems = [
  {
    num: '01',
    title: 'データ入力・書類整理',
    desc: '就労支援の参加者が担当。丁寧な作業で品質を担保します。',
  },
  {
    num: '02',
    title: '品質管理・窓口対応',
    desc: 'ヴェリテが一貫して担当。安心してアウトソースできます。',
  },
  {
    num: '03',
    title: '二重の価値',
    desc: '事務作業をアウトソースできる上に、社会貢献にも繋がります。',
  },
];